import { BoardSettingsModel } from "models/BoardSettingsModel";
import { createContext } from "react";

export interface BoardSettingsContextProps {
  boardId: string;
  boardSettings: BoardSettingsModel | undefined;
  isLoading: boolean;
  reloadBoardSettings: () => void;
}

export const BoardSettingsContext = createContext({} as BoardSettingsContextProps);
